import { useEffect, useState } from "react";

// STYLES
import * as Style from "./InvoicesStyle";

// LIBRARIES

// MISC
import { Tabs } from "models/GeneralTypes/generalTypes";
import {
  IFilters,
  IInvoicesApiParams,
  InvoicesTableData,
  IPaymentsApiParams, PaymentsTableData
} from "models/interfaces";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  language,
  selectedTab,
  toggleActiveTab,
  toggleInvoicesTabs
} from "slices/uiSlice";

// COMPONENTS
import { getAllInvoices } from "api/invoicesApi";
import { getAllPayments } from "api/paymentsApi";
import FiltersComponent from "components/FiltersComponent/FiltersComponent";
import DynamicTable from "components/Table/Table";
import TabsComponent from "components/Tabs/Tabs";
import { invoicesData, invoicesFilters, invoicesTotalPages, toggleClearInvoicesTableData } from "slices/invoicesSlice";
import { paymentsData, paymentsFilters, paymentsTotalPages, toggleClearPaymentsTableData } from "slices/paymentsSlice";
import { filters, handleResetFiltersState } from "slices/filtersSlice";
import moment from "moment";

const Invoices = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const invoicesTableDatas = useAppSelector<InvoicesTableData[]>(invoicesData);
  const paymentsTableDatas = useAppSelector<PaymentsTableData[]>(paymentsData)
  const invoicesTotalPage = useAppSelector<number>(invoicesTotalPages);
  const paymentsTotalPage = useAppSelector<number>(paymentsTotalPages);
  const invoicesFiltersValue = useAppSelector<IInvoicesApiParams>(invoicesFilters);
  const paymentsFiltersValue = useAppSelector<IPaymentsApiParams>(paymentsFilters);
  const selectedLanguage = useAppSelector<string>(language);
  const activeTab = useAppSelector<string>(selectedTab);
  const filtersData = useAppSelector<IFilters>(filters);

  // CONSTANTS USING HOOKS
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(toggleInvoicesTabs());
    dispatch(toggleActiveTab(Tabs.PAYMENTS));
    // dispatch(handleResetFiltersState());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsLoading(true);
    let payload: IPaymentsApiParams = {
      userFullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    if (activeTab === Tabs.PAYMENTS) {
      dispatch(getAllPayments(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearInvoicesTableData());
          setIsLoading(false);
        })
    } else if (activeTab === Tabs.INVOICES_LOGS) {
      dispatch(getAllInvoices(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearPaymentsTableData());
          setIsLoading(false);
        })
    }
    // eslint-disable-next-line
  }, [activeTab, invoicesFiltersValue, paymentsFiltersValue, selectedLanguage]);
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.InvoicesContainer>

      <FiltersComponent />
      {!isLoading ?
        <>
          {paymentsTableDatas &&
            <DynamicTable
              totalPages={paymentsTotalPage}
              tableData={paymentsTableDatas}
            />
          }
          {invoicesTableDatas &&
            <DynamicTable
              totalPages={invoicesTotalPage}
              tableData={invoicesTableDatas}
            />
          }
        </> : <Style.LodingSign />
      }
    </Style.InvoicesContainer>
  );
};

export default Invoices;
